export const GENERATIONS_IMAGE_COST = 100;
export const GENERATIONS_SKIP_COST = 300;
// Keep these aligned with Unlimited / POWERUP_COSTS defaults (economyCatalog.js)
export const GENERATIONS_INSPECT_COST = 100;
export const GENERATIONS_ZOOM_OUT_COST = 300;

// Buffering (prefetch) generates the *next* AI image WITHOUT charging coins (prefetch: true).
// Coins are charged when the buffered round is consumed:
//   - Next Round: GENERATIONS_IMAGE_COST (100)
//   - Skip: GENERATIONS_SKIP_COST (300) — includes the image cost.
// To prefetch the buffer, the user must be able to afford at least the skip cost
// (the most expensive consumption path) so the buffer isn't wasted.
export const GENERATIONS_MIN_COINS_TO_BUFFER_SKIP = GENERATIONS_SKIP_COST;

export const INITIAL_ZOOM = 1000;
export const ZOOM_DECREASE = 225;
export const MIN_ZOOM = 100;
export const WIN_MODAL_DELAY = 900;
export const ERROR_DISPLAY_TIME = 2000;

export const DEFAULT_GENERATIONS_STATS = {
  guesses: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 },
  losses: 0,
  currentStreak: 0,
  maxStreak: 0,
};

export const INITIAL_GAME_STATE = {
  solution: '',
  imageUrl: '',
  guesses: Array(5).fill(''),
  currentGuess: '',
  currentRow: 0,
  gameOver: false,
  zoomLevel: INITIAL_ZOOM,
  // Random origin for the zoom offset (generated per round). null = center.
  zoomOrigin: null,
  loading: false,
  isChecking: false,
  isRequestPending: false,
  // Separate flag for background buffering (prefetch). Keep it separate from isRequestPending
  // so typing/round state can remain responsive while the next round loads.
  isPrefetchPending: false,
};
